(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-static-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hc-static-slideshow')) {
    const SUPPORTS_INERT = 'inert' in HTMLElement.prototype;

    customElements.define('hc-static-slideshow', class HCStaticSlideshow extends HTMLElement {
      // The constructor must not touch children: when this file is bundled into a
      // shared asset the element can be upgraded mid-parse, before they exist.
      constructor() {
        super();
        this.ready = false;
      }

      connectedCallback() {
        if (!this.ready) {
          this.setup();
          this.ready = true;
        }
        // Re-registering the same reference is a no-op, so this is safe to run
        // on every reconnect.
        this.motionQuery.addEventListener('change', this.onMotionChange);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.motionQuery) this.motionQuery.removeEventListener('change', this.onMotionChange);
      }

      setup() {
        this.list = this.querySelector('.hc-slideshow__list');
        this.items = Array.from(this.querySelectorAll('.hc-slideshow__item'));
        this.dots = Array.from(this.querySelectorAll('.hc-slideshow__dot'));
        this.prevButton = this.querySelector('.hc-slideshow__arrow--prev');
        this.nextButton = this.querySelector('.hc-slideshow__arrow--next');
        this.pauseButton = this.querySelector('.hc-slideshow__pause');

        this.currentIndex = 0;
        this.autoplaySpeed = Number.parseInt(this.dataset.autoplay, 10) || 0;
        this.autoplayTimer = null;
        this.pointerInside = false;
        this.focusInside = false;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotionChange = this.handleMotionChange.bind(this);

        // Someone who asked their OS to reduce motion gets a stopped carousel
        // they can start, not a moving one they have to stop.
        this.userPaused = this.motionQuery.matches;

        this.applySchedule();
        this.init();
      }

      // Removes slides outside their scheduled window. Must run before init() so
      // dots, hydration and accessibility indices are built from the surviving
      // slides only. Skipped in the theme editor: a merchant scheduling next
      // week's slide still has to be able to see and select it.
      applySchedule() {
        if (window.Shopify && window.Shopify.designMode) return;

        const now = Date.now();
        const timeZone = this.dataset.timezone || '';
        const expired = new Set();

        this.items.forEach((item, index) => {
          const start = this.parseBoundary(item.dataset.start, timeZone, false);
          const end = this.parseBoundary(item.dataset.end, timeZone, true);
          if (start !== null && now < start) expired.add(index);
          if (end !== null && now > end) expired.add(index);
        });

        if (expired.size === 0) return;

        if (expired.size === this.items.length) {
          this.hidden = true;
          this.items = [];
          this.dots = [];
          return;
        }

        expired.forEach((index) => {
          this.items[index].remove();
          if (this.dots[index]) this.dots[index].remove();
        });

        this.items = this.items.filter((_, index) => !expired.has(index));
        this.dots = this.dots.filter((_, index) => !expired.has(index));

        this.items.forEach((item, index) => {
          item.setAttribute('aria-label', `${index + 1} of ${this.items.length}`);
        });

        this.dots.forEach((dot, index) => {
          dot.dataset.index = index;
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.setAttribute('aria-controls', this.items[index].id);
          dot.classList.toggle('hc-slideshow__dot--active', index === 0);
          dot.setAttribute('aria-current', String(index === 0));
        });

        if (this.items.length <= 1) {
          const pagination = this.querySelector('.hc-slideshow__pagination');
          if (pagination) pagination.hidden = true;
        }

        // The slide Liquid marked as first may have just been removed, so make
        // sure whatever now leads the deck has its images.
        this.hydrateSlide(0);
        this.hydrateSlide(1);
      }

      // "2026-03-15T14:30" is wall-clock time in the section's timezone, not an
      // instant — resolve it to one. An end boundary covers the minute it names.
      parseBoundary(value, timeZone, isEnd) {
        if (!value) return null;

        const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value);
        if (!parts) {
          console.warn(`[hc-static-slideshow] Ignoring unreadable schedule value "${value}"`);
          return null;
        }

        const [year, month, day, hour, minute] = parts.slice(1).map(Number);
        const wallClock = Date.UTC(year, month - 1, day, hour, minute);

        let epoch = wallClock - this.zoneOffset(wallClock, timeZone);
        // Re-resolve once: the first guess can land on the wrong side of a
        // daylight-saving transition and pick up the wrong offset.
        epoch = wallClock - this.zoneOffset(epoch, timeZone);

        return isEnd ? epoch + 59999 : epoch;
      }

      // Milliseconds that timeZone is ahead of UTC at the given instant.
      zoneOffset(epoch, timeZone) {
        if (!timeZone) return -new Date(epoch).getTimezoneOffset() * 60000;

        let formatted;
        try {
          formatted = new Intl.DateTimeFormat('en-US', {
            timeZone,
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          }).formatToParts(new Date(epoch));
        } catch (error) {
          console.warn(`[hc-static-slideshow] Unknown timezone "${timeZone}", using the visitor's`);
          return -new Date(epoch).getTimezoneOffset() * 60000;
        }

        const field = {};
        formatted.forEach((part) => { field[part.type] = part.value; });

        // Some engines render midnight as hour 24.
        const hour = field.hour === '24' ? 0 : Number(field.hour);
        const asUTC = Date.UTC(
          Number(field.year), Number(field.month) - 1, Number(field.day),
          hour, Number(field.minute), Number(field.second)
        );

        return asUTC - epoch;
      }

      init() {
        if (this.items.length <= 1) {
          if (this.prevButton) this.prevButton.hidden = true;
          if (this.nextButton) this.nextButton.hidden = true;
          if (this.pauseButton) this.pauseButton.hidden = true;
          this.updateAccessibility();
          return;
        }

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeyDown.bind(this));
        /*
          Hover and focus pauses are for a real mouse and real keyboard focus.
          On a phone a tap fakes a mouseenter that never gets its mouseleave,
          and leaves the tapped button focused, so either one would hold the
          carousel still forever and make the Play button look broken.
        */
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.pointerInside = true;
          this.suspendAutoplay();
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.pointerInside = false;
          this.startAutoplay();
        });
        this.addEventListener('focusin', (event) => {
          if (!this.isKeyboardFocus(event.target)) return;
          this.focusInside = true;
          this.suspendAutoplay();
        });
        this.addEventListener('focusout', () => { this.focusInside = false; this.startAutoplay(); });
        this.setupSwipe();

        this.updatePauseButton();
        this.updateAccessibility();
        this.primeNeighbours();
      }

      /*
        Get the slides either side of the first one downloading before anyone
        can reach them, rather than at the moment we rotate onto them.

        Deliberately not inside startAutoplay: with autoplay turned off that
        returns early, and the arrows would still land on an unfetched slide.
        Deliberately not immediate either — these fetches would compete with
        slide 1's, which is exactly what startAutoplay's `load` wait protects.

        `load` alone is not enough to hang this on, though. Measured on the
        live homepage on 24 Aug: 35s after navigating, readyState was still
        'interactive' — some third-party request keeps the page from ever
        reaching `load`, which also means autoplay never starts. So take
        whichever comes first, `load` or the timer. The timer is long enough
        to be clear of the first paint that the wait exists to protect, and
        hydrateSlide is idempotent, so both firing is harmless.
      */
      primeNeighbours() {
        if (document.readyState === 'complete') {
          this.hydrateAround(this.currentIndex);
          return;
        }

        const prime = () => this.hydrateAround(this.currentIndex);
        window.addEventListener('load', prime, { once: true });
        setTimeout(prime, 5000);
      }

      handleMotionChange(event) {
        this.userPaused = event.matches;
        if (this.userPaused) this.stopAutoplay(); else this.startAutoplay();
        this.updatePauseButton();
      }

      handleClick(event) {
        const target = event.target.closest('button');
        if (!target) return;

        if (target === this.pauseButton) {
          this.userPaused = !this.userPaused;
          if (this.userPaused) this.stopAutoplay(); else this.startAutoplay();
          this.updatePauseButton();
          return;
        }

        if (target === this.prevButton) {
          this.goToSlide(this.currentIndex - 1);
        } else if (target === this.nextButton) {
          this.goToSlide(this.currentIndex + 1);
        } else if (target.classList.contains('hc-slideshow__dot')) {
          const index = Number.parseInt(target.dataset.index, 10);
          if (Number.isNaN(index)) return;
          this.goToSlide(index);
        } else {
          return;
        }

        this.restartAutoplay();
      }

      isKeyboardFocus(element) {
        try {
          return element.matches(':focus-visible');
        } catch (error) {
          return true;
        }
      }

      // Moving by hand gives the visitor a full interval on the slide they
      // chose, then rotation carries on. Only the Pause button stops it for good.
      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
        this.updateLiveRegion();
      }

      /*
        Touch swipe. The slide follows the finger, and on release it moves on
        if the drag passed a fifth of the slide or was a quick flick; otherwise
        it springs back. The axis is decided on the first real movement: a
        mostly vertical drag is left to the browser so the page still scrolls.
      */
      setupSwipe() {
        const viewport = this.querySelector('.hc-slideshow__viewport');
        if (!viewport) return;

        let startX = 0;
        let startY = 0;
        let startTime = 0;
        let deltaX = 0;
        let axis = null;
        this.justSwiped = false;

        const reset = () => {
          axis = null;
          deltaX = 0;
          this.list.classList.remove('hc-slideshow__list--dragging');
        };

        viewport.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) { reset(); return; }
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          startTime = Date.now();
          deltaX = 0;
          axis = null;
          this.pointerInside = true;
          this.suspendAutoplay();
        }, { passive: true });

        viewport.addEventListener('touchmove', (event) => {
          if (event.touches.length !== 1) return;
          const dx = event.touches[0].clientX - startX;
          const dy = event.touches[0].clientY - startY;

          if (axis === null) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            if (axis === 'x') this.list.classList.add('hc-slideshow__list--dragging');
          }
          if (axis !== 'x') return;

          deltaX = dx;
          // Past either end the drag gets heavy, so the empty space beyond
          // the strip barely shows before the loop wraps around.
          const atEdge = (this.currentIndex === 0 && dx > 0)
            || (this.currentIndex === this.items.length - 1 && dx < 0);
          const shown = atEdge ? dx / 3 : dx;
          this.list.style.transform = `translateX(calc(${-100 * this.currentIndex}% + ${shown}px))`;
        }, { passive: true });

        const finish = () => {
          this.pointerInside = false;
          if (axis !== 'x') {
            reset();
            this.startAutoplay();
            return;
          }

          const width = viewport.offsetWidth || 1;
          const fast = Math.abs(deltaX) > 30 && Date.now() - startTime < 250;
          const direction = deltaX < 0 ? 1 : -1;
          const moved = Math.abs(deltaX) > width * 0.2 || fast;

          this.list.classList.remove('hc-slideshow__list--dragging');
          this.goToSlide(moved ? this.currentIndex + direction : this.currentIndex);

          // A swipe ends on a link; don't let it open the slide.
          this.justSwiped = true;
          setTimeout(() => { this.justSwiped = false; }, 350);

          this.restartAutoplay();
          reset();
        };

        viewport.addEventListener('touchend', finish);
        viewport.addEventListener('touchcancel', finish);

        viewport.addEventListener('click', (event) => {
          if (!this.justSwiped) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);
      }

      handleKeyDown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goToSlide(this.currentIndex + (event.key === 'ArrowLeft' ? -1 : 1));
        this.restartAutoplay();
      }

      goToSlide(index) {
        if (this.items.length === 0) return;

        // Infinite loop handling
        if (index < 0) {
          this.currentIndex = this.items.length - 1;
        } else if (index >= this.items.length) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = index;
        }

        // Hydrate the target slide and both neighbours so the next
        // transition (either direction) never shows an empty slide
        this.hydrateAround(this.currentIndex);

        const offset = -100 * this.currentIndex;
        this.list.style.transform = `translateX(${offset}%)`;

        this.updateAccessibility();
        this.updateDots();
      }

      /*
        A slide and both its neighbours, so a move in either direction lands
        on something already downloading. Called on every rotation, and once
        up front by primeNeighbours — without that first call the slide after
        the first was still untouched when the carousel reached it.
      */
      hydrateAround(index) {
        const count = this.items.length;
        this.hydrateSlide(index);
        this.hydrateSlide((index + 1) % count);
        this.hydrateSlide((index - 1 + count) % count);
      }

      hydrateSlide(index) {
        const item = this.items[index];
        if (!item) return;

        /*
          Off the eager first slide every image is loading="lazy", and a
          slide parked outside the viewport by the list's translateX is not
          near enough for the browser to fetch. So the download only started
          once the slide had already slid into place, and until it arrived
          the reserved box painted as a banner-sized white gap above the
          badges bar — reported as "large space on the home page" (bug sheet
          R5, 8/24). Switching to eager here starts a pending lazy fetch
          immediately, which is the whole point of hydrating ahead.

          Before the src swap below: for slides 4+ the src does not exist yet
          and this decides how the assignment behaves. Slides never reached
          keep their images unfetched, so the saving this was built for holds.
        */
        item.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = 'eager';
        });

        item.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });
        const img = item.querySelector('img[data-src]');
        if (img) {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        }
      }

      updateDots() {
        if (this.dots.length === 0) return;
        this.dots.forEach((dot, index) => {
          const isActive = index === this.currentIndex;
          dot.classList.toggle('hc-slideshow__dot--active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
      }

      updateAccessibility() {
        this.items.forEach((item, index) => {
          const isCurrent = index === this.currentIndex;
          // aria-hidden alone would leave the slide's link in the tab order —
          // focusable content inside an aria-hidden subtree is a WCAG failure.
          if (SUPPORTS_INERT) {
            item.inert = !isCurrent;
          } else {
            item.querySelectorAll('a[href], button').forEach((node) => {
              node.tabIndex = isCurrent ? 0 : -1;
            });
          }
          item.setAttribute('aria-hidden', String(!isCurrent));
        });
      }

      // Reflects the visitor's intent, not the timer: a transient hover pause
      // shouldn't flip the icon out from under them.
      updatePauseButton() {
        if (!this.pauseButton) return;
        this.pauseButton.dataset.state = this.userPaused ? 'paused' : 'playing';
        this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
      }

      isRotating() {
        return this.autoplayTimer !== null;
      }

      updateLiveRegion() {
        if (!this.list) return;
        this.list.setAttribute('aria-live', this.isRotating() ? 'off' : 'polite');
      }

      // Hover/focus pause. Deliberately does not touch userPaused, so leaving the
      // carousel resumes only if the visitor never pressed pause themselves.
      suspendAutoplay() {
        this.stopAutoplay();
        this.updateLiveRegion();
      }

      canAutoplay() {
        return this.autoplaySpeed > 0
          && this.items.length > 1
          && !this.userPaused
          && !this.pointerInside
          && !this.focusInside
          && !this.motionQuery.matches;
      }

      startAutoplay() {
        /*
          LCP. Hold the carousel still until the page has finished loading.
          Slide 1 is the only one fetched with fetchpriority=high/eager; slides 3+
          carry their image in data-src and fetch it only when a rotation hydrates
          them. So a rotation that lands mid-load hands the largest paint to a
          slide whose download had not started yet - the 08/17/2026 PageSpeed run
          measured 26.1s of "resource load delay" against slide 7, on a page whose
          slide 1 had painted almost at once.

          Waiting for `load` keeps LCP on slide 1. Nothing visitors see after the
          page is ready changes: the same slides rotate at the same speed, they
          just stop competing with the initial render for bandwidth.
        */
        if (document.readyState !== "complete") {
          if (!this.autoplayDeferred) {
            this.autoplayDeferred = true;
            window.addEventListener(
              "load",
              () => {
                this.autoplayDeferred = false;
                this.startAutoplay();
              },
              { once: true }
            );
          }
          return;
        }

        this.stopAutoplay();
        if (this.canAutoplay()) {
          this.autoplayTimer = setInterval(() => {
            this.goToSlide(this.currentIndex + 1);
          }, this.autoplaySpeed);
        }
        this.updateLiveRegion();
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-leadership-team"]) return;
  try {
    
  (function () {
    var ZOOMS = [1, 2, 3, 4];

    // Cards in a row share one height while closed. When one opens its bio, the other cards in
    // that row keep their closed size instead of stretching to match it.
    function rowOf(li) {
      return [].filter.call(li.parentElement.children, function (other) {
        return other.offsetTop === li.offsetTop;
      });
    }

    function isOpen(li) {
      var btn = li.querySelector('.leadership-card__cta button');
      return !!btn && btn.getAttribute('aria-expanded') === 'true';
    }

    function hold(li) {
      li.style.height = li.dataset.restHeight + 'px';
      li.style.alignSelf = 'start';
    }

    function unhold(li) {
      li.style.height = '';
      li.style.alignSelf = '';
    }

    function holdRow(card) {
      var li = card.closest('li');
      if (!li || !li.parentElement) return;
      var row = rowOf(li);
      if (row.length < 2) return;
      row.forEach(function (other) {
        if (!other.dataset.restHeight) other.dataset.restHeight = other.offsetHeight;
      });
      row.forEach(function (other) {
        if (other === li) unhold(other);
        else if (!isOpen(other)) hold(other);
      });
    }

    function releaseRow(card) {
      var li = card.closest('li');
      if (!li || !li.dataset.restHeight) return;
      var row = rowOf(li);
      var anyOpen = row.some(function (other) {
        return other !== li && isOpen(other);
      });
      if (anyOpen) {
        hold(li);
        return;
      }
      row.forEach(function (other) {
        unhold(other);
        delete other.dataset.restHeight;
      });
    }

    function releaseAll() {
      document.querySelectorAll('.leadership__grid > li').forEach(function (li) {
        unhold(li);
        delete li.dataset.restHeight;
      });
    }

    // Rows change when the page switches between one and two columns.
    var twoColumns = window.matchMedia('(min-width: 960px)');
    if (twoColumns.addEventListener) twoColumns.addEventListener('change', releaseAll);

    function initCard(card) {
      var about = card.querySelector('.leadership-card__about');
      var btn = card.querySelector('.leadership-card__cta button');
      if (!about || !btn || card.hasAttribute('data-ready')) return;
      card.setAttribute('data-ready', '');
      var cta = btn.parentElement;
      var busy = false;

      about.classList.add('is-ready');

      function sync() {
        if (about.classList.contains('is-clamped')) {
          cta.hidden = about.scrollHeight <= about.clientHeight + 1;
        }
      }

      btn.addEventListener('click', function () {
        if (busy) return;
        var opening = about.classList.contains('is-clamped');
        if (opening) holdRow(card);
        btn.setAttribute('aria-expanded', String(opening));
        btn.querySelector('span').textContent = opening ? 'Read less <' : 'Read more >';

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          about.classList.toggle('is-clamped', !opening);
          if (!opening) releaseRow(card);
          return;
        }

        var from = about.offsetHeight;
        about.classList.remove('is-clamped');
        var full = about.offsetHeight;
        about.classList.add('is-clamped');
        var clamped = about.offsetHeight;
        about.classList.remove('is-clamped');

        busy = true;
        about.style.height = from + 'px';
        about.classList.add('is-animating');
        about.offsetHeight;
        about.style.height = (opening ? full : clamped) + 'px';

        function done(e) {
          if (e && e.propertyName !== 'height') return;
          about.removeEventListener('transitionend', done);
          about.classList.remove('is-animating');
          about.style.height = '';
          if (!opening) {
            about.classList.add('is-clamped');
            releaseRow(card);
          }
          busy = false;
        }
        about.addEventListener('transitionend', done);
        setTimeout(function () {
          if (busy) done();
        }, 500);
      });

      sync();
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(about);
    }

    function initMap(root) {
      var open = root.querySelector('[data-leadership-map-open]');
      var dialog = root.querySelector('[data-leadership-map]');
      if (!open || !dialog || typeof dialog.showModal !== 'function' || open.hasAttribute('data-ready')) return;
      open.setAttribute('data-ready', '');
      var stage = dialog.querySelector('[data-leadership-map-stage]');
      var level = 1;

      function setZoom(next) {
        level = Math.max(0, Math.min(ZOOMS.length - 1, next));
        // Keep the middle of what's on screen in the middle after zooming.
        var cx = (stage.scrollLeft + stage.clientWidth / 2) / (stage.scrollWidth || 1);
        var cy = (stage.scrollTop + stage.clientHeight / 2) / (stage.scrollHeight || 1);
        stage.style.setProperty('--leadership-zoom', ZOOMS[level]);
        stage.scrollLeft = cx * stage.scrollWidth - stage.clientWidth / 2;
        stage.scrollTop = cy * stage.scrollHeight - stage.clientHeight / 2;
        dialog.querySelector('[data-zoom="-1"]').disabled = level === 0;
        dialog.querySelector('[data-zoom="1"]').disabled = level === ZOOMS.length - 1;
      }

      open.addEventListener('click', function () {
        dialog.showModal();
        stage.scrollLeft = 0;
        stage.scrollTop = 0;
        setZoom(1);
      });
      dialog.querySelector('[data-leadership-map-close]').addEventListener('click', function () {
        dialog.close();
      });
      dialog.querySelectorAll('[data-zoom]').forEach(function (b) {
        b.addEventListener('click', function () {
          setZoom(level + Number(b.getAttribute('data-zoom')));
        });
      });
    }

    // A face on the map: close the map viewer if open, scroll to the person's card below the
    // sticky header, open their bio and ring the card for a moment.
    function goToCard(card) {
      var btn = card.querySelector('.leadership-card__cta button');
      if (btn && btn.getAttribute('aria-expanded') === 'false' && !btn.parentElement.hidden) btn.click();

      // Near the top the header scrolls with the page and only sticks once the page scrolls, so
      // always leave room for the stuck header plus the fixed free-shipping bar above it.
      var offset = 16;
      var header = document.querySelector('.site-header');
      if (header) offset += header.offsetHeight;
      var bar = document.querySelector('.free-shipping-bar');
      if (bar && getComputedStyle(bar).position === 'fixed') offset += bar.offsetHeight;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - offset, behavior: smooth ? 'smooth' : 'auto' });
      card.focus({ preventScroll: true });

      card.classList.add('is-highlighted');
      clearTimeout(card._leadershipTimer);
      card._leadershipTimer = setTimeout(function () {
        card.classList.remove('is-highlighted');
      }, 2000);
    }

    function initSpots(root) {
      if (root.hasAttribute('data-spots-ready')) return;
      root.setAttribute('data-spots-ready', '');
      root.addEventListener('click', function (e) {
        var spot = e.target.closest('[data-leadership-spot]');
        if (!spot) return;
        var card = document.getElementById(spot.getAttribute('href').slice(1));
        if (!card) return;
        e.preventDefault();
        var dialog = spot.closest('dialog');
        if (dialog && dialog.open) dialog.close();
        goToCard(card);
        if (window.history.replaceState) window.history.replaceState(null, '', '#' + card.id);
      });
    }

    function init(scope) {
      scope.querySelectorAll('[data-leadership-card]').forEach(initCard);
      scope.querySelectorAll('.leadership').forEach(initMap);
      scope.querySelectorAll('.leadership').forEach(initSpots);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upcoming-events"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('upcoming-events')) {
    customElements.define(
      'upcoming-events',
      class UpcomingEvents extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-upcoming-event]'));
          this.paging = this.querySelector('[data-upcoming-paging]');
          this.pages = this.querySelector('[data-upcoming-pages]');
          this.select = this.querySelector('[data-upcoming-per-page]');
          if (!this.cards.length || !this.paging) return;

          const fromSetting = String(parseInt(this.dataset.perPage, 10) || 4);
          if (!this.select.querySelector('option[value="' + fromSetting + '"]')) {
            const option = document.createElement('option');
            option.value = option.textContent = fromSetting;
            this.select.prepend(option);
          }
          this.select.value = fromSetting;
          this.page = 1;

          this.select.addEventListener('change', () => {
            this.page = 1;
            this.render();
          });

          this.render();
        }

        perPage() {
          return this.select.value === 'all' ? this.cards.length : parseInt(this.select.value, 10);
        }

        render(focusList) {
          const size = this.perPage();
          const total = Math.max(1, Math.ceil(this.cards.length / size));
          this.page = Math.min(this.page, total);

          this.cards.forEach((card, i) => {
            card.hidden = Math.floor(i / size) + 1 !== this.page;
          });

          /* Nothing to page through at the smallest size: hide the whole control. */
          const smallest = parseInt(this.select.options[0].value, 10) || 4;
          this.paging.hidden = this.cards.length <= smallest;

          this.pages.innerHTML = '';
          if (total > 1) {
            for (let n = 1; n <= total; n++) {
              const li = document.createElement('li');
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'upcoming-events__page';
              button.textContent = n;
              button.setAttribute('aria-label', 'Page ' + n);
              if (n === this.page) button.setAttribute('aria-current', 'page');
              button.addEventListener('click', () => {
                this.page = n;
                this.render(true);
              });
              li.appendChild(button);
              this.pages.appendChild(li);
            }
          }

          if (focusList) {
            const first = this.cards.find((card) => !card.hidden);
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (first) {
              first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
              const link = first.querySelector('.upcoming-event__title a');
              if (link) link.focus({ preventScroll: true });
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
